import { Link, router } from '@inertiajs/react'
import Layout from '../../../components/Layout'

interface Template { id: number; name: string; description: string | null; payload: any; created_at: string }

export default function ProjectTemplateShow({ template }: { template: Template }) {
  const lists = template.payload?.lists || []
  return (
    <Layout>
      <Link href="/project_templates" className="text-sm text-[#15532E]">← All templates</Link>
      <h1 className="text-3xl font-semibold my-4" style={{ color: '#1B1B1B' }}>{template.name}</h1>
      {template.description && <p className="text-text-muted mb-4">{template.description}</p>}
      <button onClick={() => router.post(`/project_templates/${template.id}/instantiate`)} className="mb-6 px-4 py-2 text-sm text-white rounded-lg" style={{ backgroundColor: '#ED1C24' }}>Create project from template</button>
      <div className="bg-white border rounded-lg p-4">
        <h2 className="font-semibold text-text-primary mb-3">Lists</h2>
        {lists.length === 0 ? <p className="text-sm text-text-muted">No lists in this template.</p> : (
          <ul className="space-y-3">
            {lists.map((l: any, i: number) => (
              <li key={i}>
                <h3 className="font-medium text-text-primary">{l.name}</h3>
                <ul className="ml-4 text-sm text-text-muted">
                  {(l.to_dos || []).map((td: any, j: number) => <li key={j}>• {td.title}</li>)}
                </ul>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Layout>
  )
}
